module.exports = __webpack_public_path__ + "assets/images/template/timeline.svg?v=914a89ad";